// extracted by mini-css-extract-plugin
export default {"input":"formElements__input__bJ8g4","colorError":"formElements__colorError__IzQ7e","borderError":"formElements__borderError__YLMyF"};